import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Modal, Input, Button, Select } from '../../../components';

export default function ServiceModal({ isOpen, onClose, initialData, onSuccess, companies = [] }) {
  const isEdit = !!(initialData && initialData.id);

  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);
  const [formData, setFormData] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      let initialIds = [];
      if (initialData.companies && initialData.companies.length > 0) {
        initialIds = initialData.companies.map(c => c.id);
      } else if (initialData.company_id) {
        initialIds = [initialData.company_id];
      } else if (initialData._companyId) {
        initialIds = [initialData._companyId];
      }

      setSelectedCompanyIds(initialIds);
      setFormData({
        name: initialData.name || '',
        description: initialData.description || '',
      });
    } else {
      setSelectedCompanyIds([]);
      setFormData({ name: '', description: '' });
    }
  }, [initialData, isOpen, companies]);

  function handleChange(e) {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    
    if (!selectedCompanyIds || selectedCompanyIds.length === 0) {
      toast.error('Selecione ao menos uma empresa.');
      return;
    }
    
    if (!formData.name.trim()) {
        toast.error('Nome é obrigatório.');
        return;
    }

    onSuccess({ 
        ...formData, 
        _companyIds: selectedCompanyIds 
    });
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? 'Editar Serviço' : 'Novo Serviço'}
    >
      <form onSubmit={handleSubmit} className="company-form-component">
        <div className="form-body">
          <div className="form-grid" style={{ gridTemplateColumns: '1fr' }}>
            <Select
              id="company_ids"
              label="Empresas *"
              options={companies.map(c => ({
                value: c.id,
                label: c.corporate_name || c.trade_name || c.name || c.razao_social || c.nome_fantasia || `Empresa ${c.id}`,
              }))}
              value={selectedCompanyIds}
              onChange={(e) => setSelectedCompanyIds(e.target.value)}
              placeholder="SELECIONE AS EMPRESAS..."
              searchable
              multiple
            />
            
            <Input
              id="name"
              label="Nome do Serviço"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <Input
              id="description"
              label="Descrição"
              value={formData.description}
              onChange={handleChange}
              multiline
              rows={3}
            />
          </div>
        </div>

        <div className="modal-actions">
          <Button type="button" className="cancel-button" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
